
// src/components/common/Footer.js

import React from 'react';
import { Link } from 'react-router-dom';
import brasao from '../../assets/brasao.png';
import iconFacebook from '../../assets/facebook.png';
import iconInstagram from '../../assets/instagram.png';
import iconYoutube from '../../assets/youtube.png';

const Footer = () => (
  <footer style={{
    background: 'var(--navy-dark)',
    color: 'rgba(255,255,255,0.75)',
    padding: 'var(--space-3xl) 0 var(--space-xl)',
  }}>
    <div className="container">
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 'var(--space-2xl)',
        marginBottom: 'var(--space-2xl)',
      }}>
        {/* Identidade */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem', marginBottom: '1rem' }}>
            <img
              src={brasao}
              alt="Brasão"
              style={{ width: 52, height: 52, objectFit: 'contain', filter: 'drop-shadow(0 1px 4px rgba(0,0,0,0.5))' }}
            />
            <div>
              <div style={{ color: 'var(--white)', fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '0.95rem', lineHeight: 1.3 }}>
                Paróquia N. Sra.<br />da Conceição
              </div>
              <div style={{ color: 'var(--gold)', fontSize: '0.72rem', letterSpacing: '0.06em', marginTop: '0.2rem' }}>
                Messejana · desde 1873
              </div>
            </div>
          </div>
          <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem', lineHeight: 1.7 }}>
            Servindo a comunidade com fé, esperança e caridade.
          </p>
          {/* Redes sociais */}
          <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1rem' }}>
            {[
              { label: 'Facebook',  href: 'https://www.facebook.com/Paroquiademessejanaoficial/', src: iconFacebook },
              { label: 'Instagram', href: 'https://instagram.com/paroquiademessejanaoficial', src: iconInstagram },
              { label: 'YouTube',   href: 'https://youtube.com/paroquiademessejana',   src: iconYoutube },
            ].map(({ label, href, src }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                style={{
                  width: 36, height: 36,
                  background: 'rgba(255,255,255,0.08)',
                  border: '1px solid rgba(201,160,48,0.3)',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  transition: 'all 0.2s',
                  textDecoration: 'none',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = 'var(--gold)';
                  e.currentTarget.querySelector('img').style.filter = 'brightness(0) invert(1)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                  e.currentTarget.querySelector('img').style.filter = 'brightness(0) invert(1) sepia(1) saturate(3) hue-rotate(5deg)';
                }}
              >
                <img
                  src={src}
                  alt={label}
                  style={{
                    width: 18, height: 18,
                    objectFit: 'contain',
                    filter: 'brightness(0) invert(1) sepia(1) saturate(3) hue-rotate(5deg)',
                    transition: 'filter 0.2s',
                  }}
                />
              </a>
            ))}
          </div>
        </div>

        {/* Endereço */}
        <div>
          <h4 style={{ color: 'var(--gold)', marginBottom: '1rem', fontSize: '0.85rem', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
            Localização
          </h4>
          <p style={{ fontSize: '0.875rem', lineHeight: 1.8, color: 'rgba(255,255,255,0.65)' }}>
            R. Joaquim Bezerra, 235<br />
            Messejana – CEP 60842-010<br />
            Fortaleza – CE
          </p>
          <p style={{ fontSize: '0.875rem', marginTop: '0.75rem', color: 'rgba(255,255,255,0.65)' }}>
            📱 (85) 98134-6247
          </p>
        </div>

        {/* Missas */}
        <div>
          <h4 style={{ color: 'var(--gold)', marginBottom: '1rem', fontSize: '0.85rem', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
            Horários das Missas
          </h4>
          <ul style={{ listStyle: 'none', fontSize: '0.875rem', color: 'rgba(255,255,255,0.65)', lineHeight: 2 }}>
            <li>Segunda a Sexta: 17:30</li>
            <li>Domingo: 7h, 17h e 19h</li>
          </ul>
        </div>

        {/* Secretaria */}
        <div>
          <h4 style={{ color: 'var(--gold)', marginBottom: '1rem', fontSize: '0.85rem', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
            Secretaria
          </h4>
          <ul style={{ listStyle: 'none', fontSize: '0.875rem', color: 'rgba(255,255,255,0.65)', lineHeight: 2 }}>
            <li>Segunda a Sexta:</li>
            <li>Manhã: 8h às 12h</li>
            <li>Tarde: 13h às 17h</li>
          </ul>
          <div style={{ marginTop: '1rem' }}>
            <Link
              to="/admin/login"
              style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.3)', textDecoration: 'none' }}
            >
              Área Administrativa
            </Link>
          </div>
        </div>
      </div>

      {/* Linha divisória */}
      <div style={{ height: 1, background: 'rgba(201,160,48,0.2)', marginBottom: 'var(--space-lg)' }} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
        <p style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.35)' }}>
          © {new Date().getFullYear()} Paróquia Nossa Senhora da Conceição – Messejana. Todos os direitos reservados.
        </p>
        <p style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.25)' }}>
          ✝ Feito com fé
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;